// extracted by mini-css-extract-plugin
export default {"formLabel":"FormLabel_formLabel__Pcz7Q","formLabelRequired":"FormLabel_formLabelRequired__3osoo FormLabel_formLabel__Pcz7Q"};